import React from 'react'
import cn from 'classnames'
import classes from './Fieldset.module.scss'

interface FieldsetProps extends React.HTMLProps<HTMLFieldSetElement> {
  large?: boolean
}

export const Fieldset: React.FunctionComponent<FieldsetProps> = ({
  children,
  large = false,
  ...rest
}) => (
  <fieldset
    className={cn(classes.fieldset, { [classes.large]: large })}
    {...rest}
  >
    {children}
  </fieldset>
)
